import { combineReducers } from "redux";
import categoriesSlice from "./slice/categories.slice";
import subcategoriesSlice from "./slice/subcategories.slice";
import alertSlice from "./slice/alert.slice";
import productsSlice from "./slice/products.slice";
import rolesSlice from "./slice/roles.slice";
import vendorsSlice from "./slice/vendors.slice";
import warehousesSlice from "./slice/warehouses.slice";
import usersSlice from "./slice/users.slice";
import authSlice from "./slice/auth.slice";
import CommercialmarketingSlice from "./slice/Commercialmarketing.slice";
import ResidentialmarketingSlice from "./slice/Residentialmarketing.slice";
import liasoningSlice from "./slice/liasoning.slice";
import dealerSlice from "./slice/dealer.slice";
import sidebarReducer from "./slice/SidebarName.slice";
import PurchaseSlice from "./slice/Purchase.slice";
import TermsSlice from "./slice/Terms.slice";
import storeSlice from "./slice/store.slice";
import accountSlice from "./slice/account.slice";
import DealerPaymentSlice from "./slice/dealerPayment.slice";
import vendorPaymentSlice from "./slice/vendorPayment.slice";
import kitproductSlice from "./slice/kitproduct.slice";
import StocktransferSlice from "./slice/Stocktransfer.slice";
import dispatchsuggestionSlice from "./slice/dispatchsuggestion.slice";
import dispatchProcessSlice from "./slice/dispatchProcess.slice";
import assigninstallerSlice from "./slice/assigninstaller.slice";
import fabricatorSlice from "./slice/fabricator.slice";
import electricianSlice from "./slice/electrician.slice";
import technicianSlice from "./slice/technician.slice";
import installerpaymentSlice from "./slice/installerpayment.slice";
import bomSlice from "./slice/bom.slice";
import salesSlice from "./slice/sales.slice";
import dashboardSlice from './slice/dashboard.slice'

export const rootReducer = combineReducers({
    alert: alertSlice,
    auth: authSlice,
    roles: rolesSlice,
    sidebar: sidebarReducer,
    categories: categoriesSlice,
    purchase: PurchaseSlice,
    subcategories: subcategoriesSlice,
    products: productsSlice,
    vendors: vendorsSlice,
    warehouses: warehousesSlice,
    users: usersSlice,
    store: storeSlice,
    comMarketing: CommercialmarketingSlice,
    resMarketing: ResidentialmarketingSlice,
    liasoning: liasoningSlice,
    dealer: dealerSlice,
    Terms: TermsSlice,
    account: accountSlice,
    dealerPayment: DealerPaymentSlice,
    vendorPayment: vendorPaymentSlice,
    kitproduct: kitproductSlice,
    stocktransfer: StocktransferSlice,
    dispatchsuggestion: dispatchsuggestionSlice,
    dispatchProcess: dispatchProcessSlice,
    assignInstaller: assigninstallerSlice,
    fabricator: fabricatorSlice,
    electrician: electricianSlice,
    technician: technicianSlice,
    installerpayment: installerpaymentSlice,
    bom: bomSlice,
    sales: salesSlice,
    dashboard: dashboardSlice,
});
